
import ManningContentUtils from "../../../ts/utils/ManningContentUtils";

class ManningOnlineUtilsClass {
    public expandLinkWithChapterLink(link: string, title: string): string {
        if(!link || !title) { return link; }

        if(link.indexOf("chapter-") >= 0 
        || link.indexOf("part-") >= 0 
        || link.indexOf("appendix") >= 0
        || link.indexOf("/book/") == -1) {
            return link;
        }

        const match = title.match(/(chapter\s[0-9]+)|(appendix([a-z])?)|(part-[0-9]+)/i);
        if(match == null || !match[0]) { return link; }

        const matchedChapter = (match[0] || "").toLowerCase().replace(" ", "-");
        return link + "/" + matchedChapter;
    }
    
    public fixNewsTitle(title: string, productTitle: string): string {
        let value = title
        const cleanProductTitle = ManningContentUtils.getShortTitle(productTitle);

        if(title.indexOf(productTitle) >= 0){
            value = title.replace(productTitle, "").trim();
        }
        else if(title.indexOf(cleanProductTitle) >= 0){
            value = title.replace(cleanProductTitle, "").trim();
        }

        const replaceStrings = ["- ", "Mobile release", "MEAP published"];

        for(const item of replaceStrings){
            value = value.replace(item, "").trim();
        }

        if(!value) { return title; }

        value += ", in <em>" + cleanProductTitle + "</em>";

        return value;
    }
    
    public extractDescriptionFromSummary(summary: string): string {
        if(!summary) { return ""; }
        
        const template = document.createElement("template");        
        template.innerHTML = summary;

        let result = "";

        const list = template.content.querySelector("ul");
        if(list != null) {
            const listItems = list.querySelectorAll("li")
            for(let i = 0; i < listItems.length; i++) {
                if(result) {
                    result += " • ";
                }
                
                result += listItems[i].innerHTML;
            }

            if(list.previousElementSibling != null) {
                list.previousElementSibling.remove();
            }
            
            list.remove();

            if(result) {
                result += "<br/>";
            }
        }

        const boldElements = template.content.querySelectorAll("b");
        for(let i = 0; i < boldElements.length; i++) {
            if(boldElements[i].textContent.indexOf("What's new?")){
                boldElements[i].remove();
            }
        }

        result += template.content.textContent;
        return result;
    }
}

export const ManningOnlineUtils = new ManningOnlineUtilsClass();